module.exports = __webpack_public_path__ + "img/second-avater-1@2x.035fc3d.png";